module.exports = __webpack_public_path__ + "img/icon-pain-1.97fb2004.png";